<template>
  <div class="live-data">
    <transition name="slide">
      <div :key="broadcast.liveDataUpdatedAt" class="slide" :class="{ playing }">
        <div ref="thumbnail" class="thumbnail">
          <img
            v-if="thumbnailUrl"
            :src="getImage(thumbnailUrl) || thumbnailUrl"
          >
        </div>
        <div class="gradient" />
        <div class="now-playing">
          <div class="title">
            {{ broadcast.title }}
          </div>
          <div class="subtitle">
            {{ broadcast.artist || broadcast.subject }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LiveData',
  props: {
    broadcast: {
      type: Object,
      default: () => {},
    },
    playing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('prefetcher', { getImage: 'get' }),

    thumbnailUrl() {
      return (this.broadcast.liveImageUrl || this.broadcast.logoUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";

$station-color: #fefefe;
$station-bakgroung-color: #363333;

%fill-parent {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.live-data {
  @extend %fill-parent;
  overflow: hidden;

  $station-color: #fefefe;

  .slide {
    @extend %fill-parent;
  }

  .slide-enter-active, .slide-leave-active  {
    transition: all 1s cubic-bezier(.25, .1, .25, 1);
  }

  .slide-enter {
    transform: translateX(100%);
  }

  .slide-leave-to {
    transform: translateX(-50%);
    opacity: 0.2;
  }

  .playing {
    .gradient {
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
      border: 4px solid $station-color;
      border-bottom: 0;
    }
  }

  .gradient {
    @extend %fill-parent;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));
    transition: background-image 0.2s ease-in, border 0.2s ease-in;
  }

  .thumbnail {
    @extend %fill-parent;
    background-repeat: no-repeat;
    background-size: 100%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .now-playing {
    position: absolute;
    bottom: 25%;
    white-space: nowrap;
    overflow: hidden;
    padding: 0.3em 0.4em;
    width: 100%;
    box-sizing: border-box;

    .title {
      font-size: 0.57em;
      font-family: 'AltGoth', Helvetica, Arial, sans-serif;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0.15em;
    }

    .subtitle {
      font-weight: $weight-normal;
      letter-spacing: .2px;
      font-size: 0.34em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
